var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.00001,
    fill: "none",
    height: 32,
    width: 32
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16,31.00002a3.9,3.9 0 0 1 -1.92,-0.5l-10.18,-5.67a3.63,3.63 0 0 1 -1.9,-3.16l0,-11.35a3.64,3.64 0 0 1 1.89,-3.15l10.19,-5.68a4,4 0 0 1 1.92,-0.49a3.91,3.91 0 0 1 1.93,0.5l10.17,5.67a3.63,3.63 0 0 1 1.9,3.16l0,11.35a3.64,3.64 0 0 1 -1.89,3.15l-10.19,5.68a4,4 0 0 1 -1.92,0.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16,2.00001a2.92,2.92 0 0 1 1.42,0.37l10.2,5.68a2.64,2.64 0 0 1 1.38,2.27l0,11.34a2.66,2.66 0 0 1 -1.38,2.34l-10.18,5.63a3,3 0 0 1 -1.44,0.37a3,3 0 0 1 -1.43,-0.37l-10.2,-5.63a2.64,2.64 0 0 1 -1.37,-2.32l0,-11.34a2.66,2.66 0 0 1 1.38,-2.34l10.18,-5.63a3,3 0 0 1 1.44,-0.37l0,0m0,-2l0,0a4.93,4.93 0 0 0 -2.4,0.62l-10.19,5.68a4.62,4.62 0 0 0 -2.41,4l0,11.38a4.62,4.62 0 0 0 2.41,4l10.18,5.68a5,5 0 0 0 4.82,0l10.18,-5.66a4.62,4.62 0 0 0 2.41,-4l0,-11.38a4.62,4.62 0 0 0 -2.41,-4l-10.18,-5.7a4.93,4.93 0 0 0 -2.41,-0.62z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("desc", {
    stroke: "null"
  }, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    fillRule: "evenodd",
    fill: "none",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "translate(-136 -1489)",
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "translate(100 1428)",
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "translate(34 54)",
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    points: "8.310786247253418,13.195170929559367 27.8107852935791,13.195170929559367 27.8107852935791,34.195173257277474 8.310786247253418,34.195173257277474 ",
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#04A6FC",
    id: "svg_5",
    d: "m22.12328,19.32017l-2.4375,0c-0.44687,0 -0.8125,0.39375 -0.8125,0.875c0,0.48125 0.36563,0.875 0.8125,0.875l2.4375,0c1.34063,0 2.4375,1.18125 2.4375,2.625c0,1.44375 -1.09687,2.625 -2.4375,2.625l-2.4375,0c-0.44687,0 -0.8125,0.39375 -0.8125,0.875c0,0.48125 0.36563,0.875 0.8125,0.875l2.4375,0c2.2425,0 4.0625,-1.96 4.0625,-4.375c0,-2.415 -1.82,-4.375 -4.0625,-4.375zm-7.3125,4.375c0,0.48125 0.36563,0.875 0.8125,0.875l4.875,0c0.44688,0 0.8125,-0.39375 0.8125,-0.875c0,-0.48125 -0.36562,-0.875 -0.8125,-0.875l-4.875,0c-0.44687,0 -0.8125,0.39375 -0.8125,0.875zm1.625,2.625l-2.4375,0c-1.34063,0 -2.4375,-1.18125 -2.4375,-2.625c0,-1.44375 1.09687,-2.625 2.4375,-2.625l2.4375,0c0.44688,0 0.8125,-0.39375 0.8125,-0.875c0,-0.48125 -0.36562,-0.875 -0.8125,-0.875l-2.4375,0c-2.2425,0 -4.0625,1.96 -4.0625,4.375c0,2.415 1.82,4.375 4.0625,4.375l2.4375,0c0.44688,0 0.8125,-0.39375 0.8125,-0.875c0,-0.48125 -0.36562,-0.875 -0.8125,-0.875z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOutline);
export default __webpack_public_path__ + "static/media/LinkOutline.00c7322b07563db9ff88137180de616c.svg";
export { ForwardRef as ReactComponent };